import React, { useEffect, useState, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSectionNew';
import TableSection from 'components/sales/tableSection/tableSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import CardSection from 'components/sales/cardSection/cardSection';
import './complaintLog.css';

const RmLog = ({
  match,
  getComplaintLog,
  complaintLog
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const Headers = ['Created By', 'Action', 'Remark','Created At'];
  const [isLoading, setIsLoading] = useState(false);
  

  useEffect(() => {
    if (getComplaintLog !== null && match.params.id)
      (async () => {
        setIsLoading(true);
        await getComplaintLog(match.params.id);
        setIsLoading(false);
      })();
  }, [getComplaintLog, match.params.id]);

 

  return (
    <Layout
      title={'Complaint Log'}
      isGoback={true}
      linkFlag={true}
      linkUrl={
        `${baseUrl}/view-complain/${match.params.id}`
      }
      isLoading={isLoading}
    >
      <div>
      { complaintLog && complaintLog.details && 
      <CardSection title={'Details'}>
        <div className="details-listing">
          <DivLayout
            heading={'Complaint Id'}
            data={complaintLog.details && complaintLog.details.complaint_id}
          />
          
          
          <DivLayout
            heading={localization.siteNumber}
            data={complaintLog.details && complaintLog.details.site_no}
          />
          <DivLayout
            heading={localization.siteName}
            data={
              complaintLog.details && complaintLog.details.client_name
            }
          />
         
         
        </div>
      </CardSection>
      }
        <FormSection title={'RM Ticket Log'}>
          <div className="details-listing">
            { complaintLog && complaintLog.data && 
            
            <TableSection
              data={complaintLog.data}
              headers={Headers}
            ></TableSection> 
            }
          </div>
        </FormSection>

        
      </div>
      
    </Layout>
  );
};

export default RmLog;
